// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"5ebdace5","238":"df6acd5d","621":"20416c0c","986":"cb5bf0f7"}[chunkId] + ".chunk.js";
};